import React, { useMemo } from "react";
import styled from "styled-components";
import Calendar from "../../organisms/Calendar";
import { Button, Modal } from "react-bootstrap";
import CardTitle from "../../organisms/CardTitle";
import { HojaDeTransportePorFecha } from "../../../services/transporteServicios";

function CalendarSection({
  transportesPorFecha,
  onFechaSeleccionada,
  debeMostrarCalendario,
  toggleMostrarCalendario,
}: {
  transportesPorFecha: Map<Date, HojaDeTransportePorFecha>;
  onFechaSeleccionada: (fecha: Date) => void;
  debeMostrarCalendario: boolean;
  toggleMostrarCalendario: (mostrar: boolean) => void;
}) {
  const fechasDeTransporte = useMemo(() => {
    if (!transportesPorFecha) {
      return [];
    }

    return Array.from(transportesPorFecha.keys());
  }, [transportesPorFecha]);

  const onDateClick = (fecha: Date) => {
    toggleMostrarCalendario(false);
    onFechaSeleccionada(fecha);
  };

  const onCerrarClick = () => {
    toggleMostrarCalendario(false);
  };

  return (
    <Modal show={debeMostrarCalendario} centered>
      <Modal.Header>
        <CardTitle>Seleccione fecha</CardTitle>
      </Modal.Header>
      <Modal.Body>
        {fechasDeTransporte && (
          <StyledCalendar
            selectRange={false}
            enabledDates={fechasDeTransporte}
            onDateClick={onDateClick}
            disableSelection={true}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex">
          <Button onClick={onCerrarClick}>Cerrar</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

const StyledCalendar = styled(Calendar)`
  width: 100%;
  border-radius: 5px;
  padding: 0%;
`;

export default CalendarSection;
